<template>
  <div>
    <vx-card>
      <div slot="no-body" class="tab-container px-6 pt-6 minus-top">
        <div class="tab-text">
          <div class = "vx-row">
            <div class="vx-col md:w-1/2 w-full mt-2">
              <vs-input
                v-validate ="'required|url'"
                data-vv-validate-on="blur"
                type ='text'
                name ='link'
                :label ="$t('adminFbIcon.path')"
                autocomplete ="off"
                class="w-full"
                v-model="form.link"
                :placeholder="$t('adminFbIcon.textPath')"
                @blur="searchFacebookUid"
              ></vs-input>
              <span class="text-danger text-sm">
                {{errors.first("link")}}
              </span>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-2">
              <vs-input
                v-validate ="'required'"
                data-vv-validate-on="blur"
                type ='text'
                name ='name'
                :label ="$t('adminFbIcon.nameFb')"
                autocomplete ="off"
                class="w-full"
                v-model="form.details.name"
                :disabled="isUpdate == false && enableInput == true"
              ></vs-input>
              <span class="text-danger text-sm" v-if="!form.details.name">
                {{errors.first("name")}}
              </span>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full mt-2">
              <vs-input
                v-validate ="'required'"
                data-vv-validate-on="blur"
                type ='text'
                name ='facebookId'
                label ='Facebook Id'
                autocomplete ="off"
                class="w-full"
                v-model="form.uid"
                :disabled="isUpdate == false && enableInput == true"
              ></vs-input>
              <span class="text-danger text-sm" v-if="!form.uid">
                {{errors.first("facebookId")}}
              </span>
            </div>
          <div class="vx-col md:w-1/2 w-full mt-2">
              <vs-select
              :disabled="isUpdate == false && enableInput == true"
              v-model="form.type"
              :label ="$t('adminFbIcon.form')"
              class="w-full"
              v-validate ="'required'"
              data-vv-validate-on="blur|change|input"
              name="formality">
                  <vs-select-item

                  v-for="(optional,index)  in optionalType"
                  :key="index"
                  :value="optional.value"
                  :text="optional.text"
                  >
                  </vs-select-item>
              </vs-select>
               <span class="text-danger text-sm">
                {{errors.first("formality")}}
              </span>
            </div>

            <div v-if = "isAdmin"  class="vx-col md:w-1/2 w-full mt-2">
              <vs-select
              :disabled ="form.type != 'group' && form.type != 'Nhóm Facebook'"
              v-model="form.private"
              :label ="$t('adminFbIcon.groupType')"
              class="w-full"
              name="groups"
              >
                  <vs-select-item
                  v-for="(optional,index)  in optionalGroup"
                  :key="index"
                  :value="optional.value"
                  :text="optional.text"
                  >
                  </vs-select-item>
              </vs-select>
               <span class="text-danger text-sm" v-if="!form.private">
                {{errors.first("groups")}}
              </span>
            </div>

            <div v-if = "isAdmin"  class="vx-col md:w-1/2 w-full mt-2">
              <vs-select
              v-model="form.priority"
              :label ="$t('adminFbIcon.priorityLevel')"
              class="w-full"
              name="groups"
              >
                  <vs-select-item
                  v-for="(optional,index)  in optionalPriority"
                  :key="index"
                  :value="optional.value"
                  :text="optional.text"
                  >
                  </vs-select-item>
              </vs-select>
               <span class="text-danger text-sm">
                {{errors.first("groups")}}
              </span>
            </div>

            <div v-if = "isAdmin"  class="vx-col md:w-1/2 w-full mt-2">
              <vs-select
              v-model="form.status"
              :label ="$t('adminFbIcon.statusFb')"
              class="w-full"
              name="status"
              >
                  <vs-select-item
                  v-for="(optional,index)  in optionalStatus"
                  :key="index"
                  :value="optional.value"
                  :text="optional.text"
                  >
                  </vs-select-item>
              </vs-select>
            </div>


          <div v-if = "isAdmin" class="vx-col md:w-1/2 w-full mt-2">
              <vs-select
              v-model="form.details.gender"
              :label ="$t('adminFbIcon.gender')"
              class="w-full"
              name="gender"
              >
                  <vs-select-item
                  v-for="(optional,index)  in optionalGender"
                  :key="index"
                  :value="optional.value"
                  :text="optional.text"
                  >
                  </vs-select-item>
              </vs-select>
            </div>

          <div v-if = "isAdmin"  class="vx-col md:w-1/2 w-full mt-2">
              <vs-input
                type ='text'
                name ='location'
                :label ="$t('adminFbIcon.address')"
                autocomplete ="off"
                class="w-full"
                v-model="form.details.location"
              ></vs-input>
            </div>

          </div>
           <div class="vx-row">
            <div class="vx-col w-full">
              <div class="mt-4 mb-4 flex flex-wrap items-center justify-end">
                <vs-button class="ml-auto mt-2 text-size" @click="saveChages" :disabled ="!validateForm">{{`${isUpdate ?
                  $t('adminFbIcon.update'): $t('adminFbIcon.create')}`}}
                </vs-button>
                <vs-button class="ml-4 mt-2 text-size" type="border" color="warning" @click="$router.go(-1)">{{$t('adminFbIcon.back')}}
                </vs-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>
<script>
import vSelect  from 'vue-select';
import Datepicker from '@/components/datepicker/Datepicker.vue';
import VueTagsInput from '@johmun/vue-tags-input';
export default {
  components:{
    VueTagsInput,
    vSelect,
    Datepicker
  },
  data(){
    return {
      isUpdate:false,
      isAdmin: false,
      enableInput:false,
      form :
        {
          uid:null,
          type:null,
          status:null,
          private:null,
          priority:null,
          optionalStatus: null,
          link:null,
          details: {
            name:null,
            gender:null,
            location:null,
            }
        }
      ,
      optionalGender:[
        {text:'Nữ',value:'female'},
        {text:'Nam',value:'male'}
      ],
      optionalPriority:[
        {text:'Bình thường',value:0},
        {text:'Ưu tiên',value:1},
        {text:'Ưu tiên đặc biệt',value:2}
      ],
      optionalStatus:[
        {text:'Hoạt động',value:true},
        {text:'Không hoạt động',value:false}
      ],
      optionalType:[
        {text:'Trang cá nhân',value:'profile'},
        {text:'Trang Facebook',value:'page'},
        {text:'Nhóm Facebook',value:'group'}
      ],
      optionalRelationship:[
        {text:'Độc thân',value:0},
        {text:'Đã kết hôn',value:1},
        {text:'Khác',value:3}
      ],
      optionalGroup:[
        {text:'Nhóm kín',value:true},
        {text:'Nhóm Công khai',value:false}
      ],
      rowDatas:[]
    }
  },
  computed:{
    // eslint-disable-next-line vue/no-dupe-keys
    validateForm(){
      return !this.errors.any();
    }
  },
  created(){
    this.initScreen();
    this.$eventBus.$on('i18n', (event) => {
      this.checkboxGender();
      this.checkboxPriority();
      this.checkboxStatus();
      this.checkboxType();
      this.checkboxRelationship();
      this.checkboxGroup();
    })
      this.checkboxGender();
      this.checkboxPriority();
      this.checkboxStatus();
      this.checkboxType();
      this.checkboxRelationship();
      this.checkboxGroup();
  },
  methods: {
        //binding data table to form
        initScreen(){
            let role = JSON.parse(localStorage.userInfo).userRole
            this.isAdmin = role == "admin";
            this.form.id = this.$route.query.id;
            const payload ={
              id:this.form.id
            };
            if(this.form.id){
              this.$processor.post('/facebook-queue/find-by-id',payload).then((response) =>{
                let data = response.data;
                let dataForm = JSON.parse(data.details);
                this.form.uid = data.uid;
                if (dataForm) {
                  this.form.details.name = dataForm.name;
                  this.form.details.location = dataForm.location ? dataForm.location.name : "";
                  this.form.details.gender = dataForm.gender;
                }
                this.form.status = data.status;
                if(data.type == 'profile'){
                  this.form.type = this.$t('adminFbIcon.profilePage')
                };
                if(data.type == 'page'){
                  this.form.type = this.$t('adminFbIcon.pageFb')
                }if(data.type == 'group'){
                  this.form.type = this.$t('adminFbIcon.groupFb')
                }
                this.form.private = data.private;
                this.form.priority = data.priority;
                this.form.link = data.link;
                this.isUpdate = true;
              })
              .catch((err) =>{
                return this.$vs.notify({
                  text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'danger'
                });
              });
            }
        },
        checkboxGender : function (){
          this.optionalGender[0].text =  this.$t('adminFbIcon.female');
          this.optionalGender[1].text =  this.$t('adminFbIcon.male');
        },
        checkboxPriority : function (){
          this.optionalPriority[0].text =  this.$t('adminFbIcon.normal');
          this.optionalPriority[1].text =  this.$t('adminFbIcon.prioritize');
          this.optionalPriority[2].text =  this.$t('adminFbIcon.specialPriority');
         },
        checkboxStatus : function (){
          this.optionalStatus[0].text =  this.$t('adminFbIcon.active');
          this.optionalStatus[1].text =  this.$t('adminFbIcon.inactive');
        },
        checkboxType : function (){
          this.optionalType[0].text =  this.$t('adminFbIcon.profilePage');
          this.optionalType[1].text =  this.$t('adminFbIcon.pageFb');
          this.optionalType[2].text =  this.$t('adminFbIcon.groupFb');
        },
        checkboxRelationship : function (){
          this.optionalRelationship[0].text =  this.$t('adminFbIcon.alone');
          this.optionalRelationship[1].text =  this.$t('adminFbIcon.married');
          this.optionalRelationship[2].text =  this.$t('adminFbIcon.other');
        },
        checkboxGroup: function (){
          this.optionalGroup[0].text =  this.$t('adminFbIcon.privateGroup');
          this.optionalGroup[1].text =  this.$t('adminFbIcon.publicGroup');
        },


        searchByFaceBookId(that){
          const payload ={
              id:this.form.id
            }
          return new Promise(function(resolve,reject) {
            that.$processor.post('/facebook-queue/find-by-id',payload).then((response) =>{
              resolve(response.data);
            }).catch((err) =>{
              reject(err);
            })
          })
        },
        searchFacebookUid(){
          if(!this.isUpdate && this.form.link && this.form.link.length){
            const payload ={
            fburl: this.form.link
          }
          this.$vs.loading();
          this.$processor.post('/facebook-queue/get-facebook-id',payload).then((res) =>{
            let data = res.data
            this.form.uid = data.uid;
            this.form.details.name = data.name;
            this.form.type  = data.type;
            if(data.status){
              this.enableInput = true;
              this.$vs.loading.close();
            }
            else{
              this.enableInput = false;
              this.$vs.loading.close();
              return this.$vs.notify({
               text: this.$t('adminFbIcon.text'),
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            })
            }
          }).
          catch((err) =>{
            this.$vs.loading.close();
            return this.$vs.notify({
               text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            })
          })
          }
        },
        checkFacebookExited(val){
            return new Set(val).size !==val.length;
        },
       async saveChages(event){
          event.preventDefault();
          if(!this.validateForm) return;
          const result = await this.$validator.validateAll();
          if (!result) return;
          this.$vs.loading();
          if (this.isUpdate) this.form.id = this.$route.query.id;
          let path = this.isUpdate ? `/facebook-queue/update/${this.form.id}` : '/facebook-queue/create';
          if(this.form.type == this.$t('adminFbIcon.profilePage')){
            this.form.type ='profile'
          };
          if(this.form.type == this.$t('adminFbIcon.pageFb')){
            this.form.type = 'page'
          }if(this.form.type == this.$t('adminFbIcon.groupFb')){
            this.form.type = 'group'
          }
          const payloadCreate =
          {
            uid: this.form.uid,
            type:this.form.type,
            status:this.form.status,
            isPrivate:this.form.private,
            priority:this.form.priority,
            link:this.form.link,
            details: JSON.stringify(this.form.details),
            priority: 1
          }
          const payloadUpdate =
          {
            uid: this.form.uid,
            type:this.form.type,
            status:this.form.status,
            private:this.form.private,
            priority:this.form.priority,
            link:this.form.link,
            details: JSON.stringify(this.form.details),
            priority: 1
          }
          let payload =this.isUpdate ? payloadUpdate:payloadCreate
          this.$processor.post(path,payload).then((response) =>{
            this.rowDatas = response.data;
            this.$vs.loading.close();
            this.$vs.notify({
               color: 'primary',
              text: `${this.isUpdate ? this.$t('adminFbIcon.update') : this.$t('adminFbIcon.add')} ` +  `${this.$t('adminFbIcon.text2')}`,
              iconPack: 'feather',
              icon: 'icon-alert-circle'
            });
            this.$router.push('/page/facebook/manage').catch(() =>{})
          }).catch((err)=>{
            this.$vs.loading.close();
            return this.$vs.notify({
               text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            })
          })
        }

  },
}
</script>
<style lang="postcss" scoped>
.title-size{
  font-size: 16px !important;
}
.text-size{
  font-size: 12px !important;
}
.minus-top{
  margin-top: -24px;
}
</style>
